import { useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import sickBabyWithMomBackground from '@assets/images/sick_baby_with_mom_background.png';
import { useDoctorSelectionContext } from '@context/DoctorSelection';
import { DOCTOR_SELECTION_BACK } from '@pages/DoctorSelection/views/DoctorSelectionView/focusKey';
import BackgroundImage from '@components/BackgroundImage';
import FocusableBackButton from '@components/FocusableBackButton';
import Loading from '@components/Loading';

import DoctorDetailView from '../DoctorDetailView';
import DoctorList from './components/DoctorList';

import * as styles from './styles';
import { makeDoctorTitle } from '@utils/doctorUtil';
import { useParams } from 'react-router-dom';

const DoctorSelectionView = () => {
  const {
    loaderVisible,
    setListLoaderVisibility,
    untactDepartment,
    doctorCount,
    isDetailVisible,
    isBlurBackground,
    setIsBlurBackground,
    goDoctorDetail,
    goBack
  } = useDoctorSelectionContext();
  const { doctorId = '' } = useParams();

  useEffect(() => {
    if (doctorId) {
      goDoctorDetail(doctorId);
    }
  }, [doctorId]);

  useEffect(() => {
    setListLoaderVisibility();
  }, [setListLoaderVisibility]);

  const { focusKey } = useFocusable();

  return (
    <FocusContext.Provider value={focusKey}>
      <div css={isBlurBackground ? [styles.container, styles.blur] : styles.container}>
        <FocusableBackButton focusKey={DOCTOR_SELECTION_BACK} onEnterPress={goBack} />
        <p css={styles.title}>{untactDepartment?.name}</p>
        <p css={styles.description}>
          {doctorCount}명의 {makeDoctorTitle(untactDepartment?.type)}가 비대면 진료
          대기중입니다.
        </p>
        <DoctorList />
        <BackgroundImage url={sickBabyWithMomBackground} filter={'blur(20px)'} />
      </div>
      <AnimatePresence
        onExitComplete={() => {
          setIsBlurBackground(false);
        }}
      >
        {isDetailVisible && <DoctorDetailView />}
      </AnimatePresence>
      <Loading visible={loaderVisible} />
    </FocusContext.Provider>
  );
};

export default DoctorSelectionView;
